import { Suspense, lazy } from 'react';

import { Loader } from 'shared/ui/Loader';

const ManufacturerManagement = lazy(() => import('./ManufacturerManagement'));

export default () => (
  <Suspense fallback={<Loader />}>
    <ManufacturerManagement />
  </Suspense>
);
